import GET_USER_BY_CPF from './getUserByCpf.gql';
import SAVE_BUSINESS_USER from './saveBusinessUser.gql';

export { GET_USER_BY_CPF, SAVE_BUSINESS_USER };
